import { useEffect, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { EnumHelperText, HelperText, Status, Switch, toastStore, Typography } from 'shared/ui'
import { MessageField } from 'widgets/MessageField'
import { AgentActionMessageStore } from '../store/agentActionMessageStore'
import { type IAgentActionContentProps } from '../types/types'

import styles from './styles.module.scss'

export const ActionMessage = observer(
  ({ control, action, error, onErrorReset }: IAgentActionContentProps) => {
    const isDirty = useRef(false)

    useEffect(() => {
      if (!(control instanceof AgentActionMessageStore)) return
      if (isDirty.current) onErrorReset()
      isDirty.current = true
    }, [control instanceof AgentActionMessageStore ? control.message.messageText : null])

    useEffect(() => {
      if (!(control instanceof AgentActionMessageStore)) return
      if (isDirty.current && control.message.textLimitReached)
        toastStore.add({
          title: control.message.textLimit.message,
          type: 'error',
        })
    }, [control instanceof AgentActionMessageStore ? control.message.textLimitReached : null])

    useEffect(() => {
      if (control instanceof AgentActionMessageStore) control.syncMessage()
    }, [])

    useEffect(() => {
      if (!(control instanceof AgentActionMessageStore)) return
      if (error) control.message.setHighlight('error')
      else control.message.clearHighlight()
    }, [error])

    if (!(control instanceof AgentActionMessageStore)) return null

    const withAutoMode = 'withAutoMode' in action && action.withAutoMode
    const isAutoMessageType = 'isAutoMessageType' in action && action.isAutoMessageType

    return (
      <div className={styles.message}>
        {withAutoMode && 'setIsAutoMessageType' in action && (
          <div className={styles.switchSection}>
            <div className={styles.switchLabelContainer}>
              <Typography
                variant='text-input-field-r'
                color='tertiary'
                ariaLabel={'GeneratedByAILabel'}
              >
                Generated by AI
              </Typography>
              <Status
                title={'Coming soon'}
                intent={'orange'}
                emphasis={'high'}
                size={'label'}
                className={styles.comingSoonStatus}
              />
            </div>
            <Switch value={isAutoMessageType} onChange={action.setIsAutoMessageType} disabled />
          </div>
        )}
        {(!withAutoMode || !isAutoMessageType) && (
          <>
            <div className={styles.field}>
              <MessageField messageFieldStore={control.message} />
            </div>
            {!!error && (
              <HelperText icon={'alertTriangleSmall'} variant={EnumHelperText.Error} text={error} />
            )}
          </>
        )}
      </div>
    )
  }
)
